import { Button, Input, Label, useToast } from "@ac-expo/ui-components";
import { ArrowLeftIcon, PasswordIcon } from "@phosphor-icons/react/dist/ssr";
import { useRouter } from "next/navigation";
import { useState } from "react";

interface EventPasswordFormProps {
  onPasswordSubmit: (password: string) => Promise<void>;
  isSubmitting?: boolean;
}

export const EventPasswordForm = ({
  onPasswordSubmit,
  isSubmitting = false,
}: EventPasswordFormProps) => {
  const router = useRouter();
  const [password, setPassword] = useState("");
  const { toast } = useToast();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!password.trim()) {
      toast({
        title: "Mot de passe requis",
        description: "Veuillez entrer le mot de passe de l'événement",
        variant: "important",
      });
      return;
    }

    await onPasswordSubmit(password);
  };

  const navigateBack = () => {
    router.back();
  };

  return (
    <div className="relative flex min-h-[500px] items-center justify-center bg-gray-50 px-4 py-12 sm:px-6 lg:px-8">
      <button
        onClick={navigateBack}
        className="absolute left-4 top-4 z-50 rounded-lg bg-white p-2 shadow-md xl:hidden"
      >
        <ArrowLeftIcon size={20} className="text-primary-500" />
      </button>
      <div className="flex flex-col w-full max-w-md gap-y-6">
        <div className="flex flex-col gap-y-1">
          <div className="flex justify-center">
            <PasswordIcon size={32} />
          </div>
          <h1 className="text-center text-3xl font-bold tracking-tight text-gray-900">
            Événement privé
          </h1>
          <p className="mt-2 text-center text-sm text-gray-600">
            L&apos;événement auquel vous souhaitez accéder est privé, saisissez
            le mot de passe pour en avoir l’accès.
          </p>
        </div>
        <form className="flex flex-col gap-y-4 px-8" onSubmit={handleSubmit}>
          <Label htmlFor="password">Mot de passe</Label>
          <Input
            id="password"
            name="password"
            type="password"
            autoComplete="off"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Mot de passe"
            disabled={isSubmitting}
          />

          <Button
            type="submit"
            variant={"blue"}
            className="w-full"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Vérification..." : "Valider"}
          </Button>
        </form>
      </div>
    </div>
  );
};
